/* global __NODE__ */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import i18n from '../../service/i18n';

translate.setI18n(i18n);

import Header from '../../parts/Header';
import Tracking from '../../parts/tracking';
import ConnectionError from '../../parts/ConnectionError';
import Meta from '../../containers/Meta';

import { buildSocketUrl } from '../../service/oms';

import { tickerDataReceived } from '../../actions/ticker';
import tickerSubscriber from '../../service/tickersubscriber';

import refreshAfterInactivity from '../../service/refreshAfterInactivity';

import ScheduledIndexTickers from '../../service/scheduledindextickers';
import { setIndexTickers } from '../../actions/indices';

import { updateDevice } from '../../actions/device';

import styles from '../../styles/app';

class App extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        dispatch: PropTypes.func.isRequired,
        location: PropTypes.object,
    }

    componentDidMount() {
        this.indexScheduler = new ScheduledIndexTickers(
            this.props.dispatch, setIndexTickers
        );

        tickerSubscriber.start(
            this.props.dispatch,
            tickerDataReceived,
            buildSocketUrl(),
        );

        window.addEventListener('resize', (e) => {
            this.props.dispatch(updateDevice(e.target.innerWidth));
        });
        this.props.dispatch(updateDevice(window.innerWidth));

        refreshAfterInactivity(true);
    }

    componentWillUnmount() {
        // clearInterval(this.sessionRefreshInterval);
        this.indexScheduler.stop();
        refreshAfterInactivity(false);
    }

    render() {
        return (
            <div className={styles.main}>
                <ConnectionError />
                <Meta />
                <Tracking pathname={this.props.location.pathname} />
                <Header />
                <div className={ styles.contentArea }>
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default connect()(App);



/** WEBPACK FOOTER **
 ** /src/shared/screens/app/index.js
 **/